<template>
  <component
    ref="filter"
    v-show="isVisible"
    :eventID="eventID"
    :is="gridFilter"
    :disabled="isDisabled"
    :config="config"
    :place="place"
    @handle="handle"/>
</template>

<script>
export default {
  name: 'GridFilter',
  props: {
    eventID: { type: String, required: true },
    config: { type: Object },
    place: { type: String, default: 'column' }
  },
  created () {
    // TODO: validate filter type
    let type = ''
    switch (this.config.type || this.config.default.type) {
      case 'checkbox':
        type = 'CheckBox'
        break
      case 'switch':
        type = 'Switch'
        break
      case 'select':
        type = 'Select'
        break
      case 'selectautocomplete':
        type = 'SelectAutoComplete'
        break
      case 'multiselectautocomplete':
        type = 'MultiSelectAutoComplete'
        break
      case 'string':
        type = 'String'
        break
      case 'datemultiple':
        type = 'DateMultiple'
        break
    }
    if (type) {
      if (['SelectAutoComplete', 'String'].some((newFilter) => newFilter === type)) {
        this.gridFilter = () => import(/* webpackChunkName: 'Grid' */ `@/components/Filters/${type}`)
      } else {
        this.gridFilter = () => import(/* webpackChunkName: 'Grid' */ `@/components/Grid/Filters/${type}/Index.vue`)
      }
    } else {
      this.handle({ type: 'error' })
    }
  },
  data () {
    return {
      gridFilter: null
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.get('permissions')
    },
    filterPermissions () {
      let result = {}
      let filterPermissions = this.copyObjectProps(new this.ModelPermissions(), this.config.permissions || {})
      Object.keys(filterPermissions).forEach((key) => {
        result[key] = this.permission(this.permissions, filterPermissions[key])
      })
      return result
    },
    isVisible () {
      return this.filterPermissions.visible
    },
    isDisabled () {
      return !this.filterPermissions.enable
    },
    removeSkip () {
      return !!(this.config.removeSkip === null
        ? this.config.type === 'string'
        : this.config.removeSkip)
    }
  },
  methods: {
    ModelPermissions () {
      return {
        enable: true,
        visible: null
      }
    },
    handle (Value) {
      this.$emit('handle', Object.assign({
        id: this.config.id,
        removeSkip: this.removeSkip,
        field: this.config.field,
        component: this.$refs.filter
      }, Value))
    }
  }
}
</script>
<style lang="stylus">
  .grid-filter {
    width 100%
    white-space nowrap
    outline none

    .el-select {
      width 100%
    }

    &.date-multiple {
      .el-input__suffix {
        pointer-events auto
      }

      .el-input {
        outline none
      }

      &.is-focus {
        .el-input__inner {
          color #495057
          border-color #80bdff
          box-shadow 0 0 0 0.32rem rgba(0, 123, 255, .25)
        }
      }
    }
  }
</style>
